import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.1 5H3.9C2.85 5 2 5.87 2 6.93V17.07C2 18.13 2.85 19 3.9 19H20.1C21.15 19 22 18.13 22 17.07V6.93C22 5.87 21.15 5 20.1 5ZM18.98 7L12 11.32L5.02 7H18.99H18.98ZM4 17V8.72L12 13.67L20 8.72V17H4Z" fill={ fill || 'currentColor' } />
    </svg>
);
